<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
      :upload-before="uploadBefore"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.companynotice_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button
          type="text"
          size="small"
          icon="el-icon-upload2"
          v-if="permission.companynotice_edit"
          @click="released(scope.row)"
          :hidden="hideReleaseBtn(scope.row)"
          >发布
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-download"
          v-if="permission.companynotice_edit"
          @click="unpublished(scope.row)"
          :hidden="hideUnpublishedBtn(scope.row)"
          >取消发布
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  updateReleased,
  updateUnpublished,
} from '@/api/v4ward/clientserve/companynotice';
import { mapGetters } from 'vuex';
import { getCommunityTree } from '../../../api/v4ward/property/baseproperty';
export default {
  data: function () {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      tempCommunityId: '',
      firstDisplayFlag: false,
      communityList: [],
      reWrite: false,
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        searchMenuSpan: 6,
        viewBtn: true,
        selection: true,
        delBtn: false,
        labelWidth: 110,
        columnBtn: false,
        refreshBtn: false,
        column: [
          {
            label: '主键',
            prop: 'id',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
          },
          {
            label: '小区',
            prop: 'communityId',
            type: 'tree',
            dataType: 'string',
            clearable: false,
            dicUrl: '/api/base/property/getCommunityTree',
            props: { label: 'title', value: 'id' },
            search: true,
            rules: [
              {
                required: true,
                message: '请选择小区',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '标题',
            prop: 'title',
            search: true,
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
            rules: [
              {
                required: true,
                message: '请输入标题',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '类型',
            prop: 'category',
            search: true,
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=notice_type',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [
              {
                required: true,
                message: '请选择类型',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '发布时间',
            prop: 'releaseTime',
            width: 135,
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
          },
          {
            label: '发布状态',
            prop: 'releaseStatus',
            search: true,
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=release_status',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [
              {
                required: true,
                message: '请选择类型',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '发布时间',
            prop: 'releaseTimeRange',
            searchRange: true,
            search: true,
            searchSpan: 10,
            type: 'datetimerange',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            span: 16,
            hide: true,
          },
          {
            label: '有效日期',
            prop: 'effectiveTimeRange',
            searchRange: true,
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            hide: true,
            rules: [
              {
                required: true,
                message: '请选择日期',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '通知内容',
            prop: 'content',
            component: 'AvueUeditor',
            params: {
              options: {
                //普通图片上传
                action: '/api/blade-resource/oss/endpoint/put-file',
                props: {
                  res: 'data',
                  url: 'link',
                },
              },
            },
            hide: true,
            minRows: 6,
            span: 24,
            rules: [
              {
                required: true,
                message: '请输入内容',
                trigger: 'change',
              },
            ],
          },
          {
            label: '有效起期',
            prop: 'effectiveStart',
            type: 'date',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            format: 'yyyy-MM-dd',
          },
          {
            label: '有效止期',
            prop: 'effectiveEnd',
            type: 'date',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            format: 'yyyy-MM-dd',
          },
          {
            label: '阅读数',
            prop: 'readMun',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
          },
          {
            label: '创建时间',
            prop: 'createTime',
            width: 135,
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.companynotice_add, false),
        viewBtn: this.vaildData(this.permission.companynotice_view, false),
        delBtn: this.vaildData(this.permission.companynotice_delete, false),
        editBtn: this.vaildData(this.permission.companynotice_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    //加载列表
    getCommunityTree({}).then((res) => {
      this.communityList = res.data;
      if (this.communityList.length > 0) {
        this.query.communityId = this.communityList[0].id;
        this.tempCommunityId = this.communityList[0].id;
      }
      this.$nextTick(() => {
        this.reWrite = true;
      });
      //每次刷新页面时，开启房产搜索框默认显示第一个节点的名称
      this.firstDisplayFlag = true;
    });
  },
  methods: {
    hideReleaseBtn(row) {
      return row.releaseStatus !== 1;
    },
    hideUnpublishedBtn(row) {
      return row.releaseStatus !== 2;
    },
    released(row) {
      updateReleased(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          console.log(error);
        }
      );
    },
    unpublished(row) {
      updateUnpublished(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          console.log(error);
        }
      );
    },
    rowSave(row, loading, done) {
      row.effectiveStart = row.effectiveTimeRange[0];
      row.effectiveEnd = row.effectiveTimeRange[1];
      if (row.content.length > 20000) {
        this.$message.error('内容最大长度2万字');
        return done();
      }
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      row.effectiveStart = row.effectiveTimeRange[0];
      row.effectiveEnd = row.effectiveTimeRange[1];
      console.log(row.content.length);
      if (row.content.length > 20000) {
        this.$message.error('内容最大长度2万字');
        return done();
      }
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
          let timeRange = [];
          timeRange.push(data.effectiveStart);
          timeRange.push(data.effectiveEnd);
          this.form.effectiveTimeRange = timeRange;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      //开启默认搜索第一个小区
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    uploadBefore(file, done, loading) {
      const isLt40MB = file.size / 1024 < 40960;
      if (!isLt40MB) {
        this.$message.error('上传文件大小不能超过40MB!');
        loading();
        return;
      }
      if (isLt40MB) {
        done();
      }
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      if (this.query.releaseTimeRange) {
        this.query.startTime = this.query.releaseTimeRange[0];
        this.query.endTime = this.query.releaseTimeRange[1];
      }
      //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
      if (this.query.communityId == undefined || this.query.communityId == '') {
        this.query.communityId = this.tempCommunityId;
      }
      if (this.query.communityId) {
        getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
          ({ data }) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
            if (this.firstDisplayFlag) {
              let ent = document.querySelector('input[placeholder="小区"]');
              ent.value = this.communityList.length > 0 ? this.communityList[0].title : '';
              this.query.communityId =
                this.communityList.length > 0 ? this.communityList[0].id : '';
              //关闭默然显示，重刷页面时才开启默认显示
              this.firstDisplayFlag = false;
            }
          }
        );
      } else {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
